<template>
  <v-container fluid>
    <v-row>
      <v-col xs="12" md="12" sm="12">
        <v-card>
          <v-card-title>
            Отчет по тарифам
          </v-card-title>

          <v-form ref="form" lazy-validation v-model="formRules.valid">
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="6" md="4" lg="4" xl="4">
                  <carusel-button
                    :getVal="getDate"
                  ></carusel-button>
                </v-col>

                <v-col xs="12" sm="6" md="4" lg="4" xl="4">
                  <carusel-button 
                    label="Тип тарифа"
                    :type="'general'"
                    :items="packageTypesGetter"
                    :getVal="getTariffType"
                  ></carusel-button>
                </v-col>

                <v-col xs="12" sm="6" md="4" lg="4" xl="4">
                  <carusel-button
                    label="Превышение"
                    :type="'general'"
                    :items="[
                      {id: ['yes'], name: 'С превышением'},
                      {id: ['no'], name: 'Без превышения'},
                      {id: ['yes', 'no'], name: 'Все'},
                    ]"
                    :getVal="getExcess"
                  ></carusel-button>
                </v-col>

                <v-col xs="12" sm="6" md="4" lg="4" xl="4">
                  <carusel-button
                    label="Статус тарифа"
                    style="margin-top:17px"
                    :type="'general'"
                    :items="[
                      {id: ['yes'], name: 'Действующий'},
                      {id: ['no'], name: 'Завершившийся'},
                      {id: ['yes', 'no'], name: 'Все'},
                    ]"
                    :getVal="getActiveTariffs"
                  ></carusel-button>
                </v-col>

                <v-col xs="12" sm="6" md="4" lg="4" xl="4" align="right">
                  <project-selector v-model="projects" />
                </v-col>


                <v-col xs="12" sm="12" md="4" lg="4" align="right">
                  <v-btn color="success" @click="loadReport" 
                  style="margin-top:17px;"
                    >Поиск</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="mt-5">
      <v-data-table
        :headers="report.headers"
        :items="tarifficationReport"
        :items-per-page="tarifficationReport.length"
        :loading="loading"
        loading-text="Загрузка..."
        no-data-text="Ничего не найдено"
        hide-default-footer
      >

        <template #top>
          <dialog-view 
            v-if="dialogView"
            v-model="dialogView"
            title="Просмотр информации о тарифе"
            fullscreen
          >
            <TarifficationModal 
              :project-id="dialogViewProjectId" 
              :period="payload['period']"
              :package-type="payload['package_type']" 
              :tariff-id="dialogViewTariffId"
            />
          </dialog-view>
        </template>

        <template #[`item.management_work_cost`]="{ item }">
          {{ item.management_work_cost }} руб.
        </template>
        <template #[`item.package_limit`]="{ item }">
          {{ item.package_limit }} мин.
        </template>
        <template #[`item.over_limit_cost`]="{ item }">
          {{ item.over_limit_cost }} руб.
        </template>
        <template #[`item.final_package_cost`]="{ item }">
          {{ item.final_package_cost }} руб.
        </template>
        <template #[`item.excess`]="{ item }">
          {{ item.excess }} мин.
        </template>
        <template #[`item.crm_work_cost`]="{ item }">
          {{ item.crm_work_cost }} руб.
        </template>
        <template #[`item.predict_min`]="{ item }">
          {{ item.predict_min }} мин.
        </template>
        <template #[`item.current_min`]="{ item }">
          {{ item.current_min }} мин.
        </template>
        <template #[`item.total_cost`]="{ item }">
          {{ item.total_cost }} руб.
        </template>

        <template #[`item.action`]="{ item }">
          <v-btn icon @click="viewItem(item)">
            <v-icon small>mdi-eye</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

  </v-container>

</template>

<style>

</style>

<script>
import moment from 'moment';

import {mapActions, mapGetters} from "vuex";
import {requiredRule} from "~/plugins/rules";
import TarifficationModal from "~/components/pages/stat/tariffication/TarifficationModal";
import CaruselButton from '~/components/partials/CaruselButton.vue';
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue';

export default {
  name: "TarifficationReport",
  components: {
    TarifficationModal,
    CaruselButton,
    ProjectSelector
  },

  data() {
    return {
      formRules: {
        valid: false,
        required: requiredRule,
      },
      dialogView: false,
      dialogViewProjectId: null,
      dialogViewTariffId: null,

      date: [],
      projects: [],
      packageType: 1,
      queues: [],
      report: {
        headers: [
          {
            text: "Название тарифа",
            value: "tariff_name",
          },
          {
            text: "Номер договора",
            value: "contract_number",
          },
          {
            text: "Номер приложения",
            value: "application_number",
          },
          {
            text: "Итоговая стоимость менеджмента", // back возвращает итоговую, исправить на стоимость ПАКЕТА без превышения
            caption: "стоимость менеджмента деленная на кол-во дней в месяце и умноженная на кол-во отработанных дней в месяце",
            value: "management_work_cost",
          },

          // {
          //   text: "Стоимость пакета",
          //   caption: "",
          //   value: "base.package_limit", // tariff_packages -> cost
          // },
          {
            text: "Итоговая стоимость пакета",
            caption: "",
            value: "final_package_cost", // tariff_packages -> cost
          },

          {
            text: "Итоговая стоимость ЦРМ",
            caption: "стоимость ЦРМ деленная на кол-во дней в месяце и умноженная на кол-во отработанных дней в месяце",
            value: "crm_work_cost",
          },

          {
            text: "Итоговая стоимость превышения минут",
            caption: "если превышение больше 0, то кол-во минут превышения умноженное на стоимость превышения",
            value: "over_limit_cost",
          },
          {
            // ToDo на бэке
            text: "Итоговая сумма",
            caption: "итоговая сумма за весь тариф с учетом превышения и отработанных дней",
            value: "total_cost",
          },

          {
            text: '',
            value: 'action',
            sortable: false,
          }

          // {
          //   text: 'Прогноз минут',
          //   caption: "((кол-во минут за 28 дней со вчерашнего дня (не превышая даты старта тарифа) деленное на 28 (на кол-во дней от старта тарифа до вчера)) умноженное на кол-во оставшихся дней в месяце включая сегодня) плюс кол-во минут с 1го числа по вчера включительно (со старта тарифа по вчера)",
          //   value: 'predict_min',
          // },
          // {
          //   text: 'Прогноз посекундная',
          //   caption: "((кол-во минут за 28 дней со вчерашнего дня (не превышая даты старта тарифа) деленное на 28 (на кол-во дней от старта тарифа до вчера)) умноженное на кол-во оставшихся дней в месяце включая сегодня) плюс кол-во минут с 1го числа по вчера включительно (со старта тарифа по вчера)",
          //   value: 'predict_sec',
          // },
          // {
          //   text: 'Превышение минут',
          //   caption: "прогноз минут вычесть кол-во минут в пакете",
          //   value: 'excess',
          // },
          // {
          //   text: 'Превышение  посекундная',
          //   caption: "прогноз минут вычесть кол-во минут в пакете",
          //   value: '',
          // },
          // {
          //   text: 'Выговорено минут',
          //   caption: "кол-во минут с 1го числа по вчера (с даты старта тарифа по вчера)",
          //   value: 'current_min',
          // },
          // {
          //   text: 'Выговорено секунд ',
          //   caption: "кол-во минут с 1го числа по вчера (с даты старта тарифа по вчера)",
          //   value: 'current_sec',
          // },
        ],
        items: [],
        projectInfo: {},
        projectWiretapIsNeeded: false,
      },
      activeTariffs: ['yes'],
      excess: ['yes'],
    }
  },

  computed: {
    ...mapGetters({
      hasPermission: "user/hasPermission",
      // projectsGetter: "projects/projects",
      queuesGetter: "projects/queues",
      filteredQueues: "projects/filteredQueues",
      loading: "shared/getLoading",
      meta: "shared/meta",
      packageTypesGetter: 'tariffs/packageTypes',
      tarifficationReport: 'tariffications/tarifficationReport',
    }),

    payload() {
      return {
        projects: this.projects,
        period: this.date,
        package_type: this.packageType,
        excess: this.excess,
        active: this.activeTariffs,
      }
    },
  },

  watch: {},

  methods: {
    ...mapActions({
      loadProjects: 'projects/loadProjects',
      loadWiretappingRate: 'reports_speech_analysis/loadWiretappingRate',
      loadPackageTypes: 'tariffs/loadPackageTypes',
      loadTarifficationsReport: 'tariffications/loadTarifficationsReport',
      resetAllState: 'resetAllState',
    }),

    viewItem(tariff) {
      this.dialogViewProjectId = tariff['project_id'];
      this.dialogViewTariffId = tariff['id'];
      this.dialogView = true;
    },

    getDate(data) {
      this.date = [
        moment(data.start).format("YYYY-MM-DD"), 
        moment(data.end).format("YYYY-MM-DD")
      ];
    },
    
    getTariffType(data) {
      this.packageType = data;
    },

    getExcess(data) {
      this.excess = data;
    },

    getActiveTariffs(data) {
      this.activeTariffs = data;
    },

    async loadReport() {
      if (this.$refs.form.validate()) {
        await this.loadTarifficationsReport(this.payload);
      }
    },

  },

  mounted() {
    this.loadProjects({with: 'queues, tags'});
    this.loadPackageTypes();
  },

  beforeDestroy() {
    this.resetAllState();
  },
}
</script>

<style scoped>

</style>